import { render, staticRenderFns } from "./goodsTagCell.vue?vue&type=template&id=39a23450&scoped=true"
import script from "./goodsTagCell.vue?vue&type=script&lang=js"
export * from "./goodsTagCell.vue?vue&type=script&lang=js"
import style0 from "./goodsTagCell.vue?vue&type=style&index=0&id=39a23450&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a23450",
  null
  
)

export default component.exports